import { css } from '@emotion/css';

const paneStyle = () => css({
	display: 'grid',
	gridTemplateColumns: '30px 1fr',
	gap: '1em'
});

const contentsStyle = () => css({
	overflow: 'auto'
});


export function IconPane(P)
{
	return (
		<div class={paneStyle()}>
			<div>
				{P.children[0]}
			</div>
			<div class={contentsStyle()}>
				{P.children[1]}
			</div>
		</div>
	);
}
